export default __webpack_public_path__ + "565b999c706f54e22edcd4c2dd58c033.svg";